export default __webpack_public_path__ + "static/media/avatar_panda6.b9854cc7.mp3";